// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"Breadcrumbs_breadcrumbs__xQ9dn","back":"Breadcrumbs_back__N-YcY"};